import React, { Fragment } from 'react';
import styled from 'styled-components';

import { Checkbox } from 'antd';

import 'antd/lib/checkbox/style/index.css';

import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import CtaCard from 'components/ui/CtaCard';

import EmptySelectState from './EmptySelectState';
import { SearchInput } from './SearchInput';
import { colors } from 'helpers/ColorHelper';

import { getTranslatedString } from 'helpers/i18n';

const StyledSelectContainer = styled.div`
  padding: 5px 14px;
`;

const StyledCheckboxContainer = styled.div`
  padding-bottom: 5px;
  padding-top: 5px;
`;
const StyledContainerBoarderBottom = styled(StyledCheckboxContainer)`
  border-bottom: 1px solid ${colors.LIGHT_GREY};
`;

export const StyledLink = styled(CtaCard)`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  text-align: right;
  float: right;
`;

const Selector = ({
  handleSearch,
  indeterminate,
  onOptionCheckAllChange,
  checkAll,
  options,
  selected,
  verbiage,
  onOptionSelect,
}) => {
  return (
    <Fragment>
      <SearchInput handleChange={handleSearch} />
      <StyledSelectContainer>
        <StyledContainerBoarderBottom>
          <Row>
            <Col span={12}>
              <Checkbox
                indeterminate={indeterminate}
                onChange={onOptionCheckAllChange}
                checked={checkAll}
                disabled={options.length === 0}
              >
                {getTranslatedString('landlordPortal.filterAndSelect.selectAll')}
              </Checkbox>
            </Col>
            <Col span={12}>
              {selected.length > 0 && (
                <StyledLink onClick={() => onOptionSelect([], true)} type="button">
                  {getTranslatedString('landlordPortal.filterAndSelect.clearSelection')}
                </StyledLink>
              )}
            </Col>
          </Row>
        </StyledContainerBoarderBottom>
        {options.length === 0 ? (
          <EmptySelectState optionTitle={verbiage.optionTitle} />
        ) : (
          <Checkbox.Group value={selected} onChange={onOptionSelect}>
            {options.map((option) => {
              return (
                <StyledCheckboxContainer key={`filtersOptions-${option.attributes.value}`}>
                  <Checkbox
                    value={option.attributes.value}
                    key={`filtersOptions-${option.attributes.value}`}
                  >
                    {option.attributes.label}
                  </Checkbox>
                </StyledCheckboxContainer>
              );
            })}
          </Checkbox.Group>
        )}
      </StyledSelectContainer>
    </Fragment>
  );
};

export default Selector;
